import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../../test-utils/html-validate";

describe("tab-container", () => {
    it("should render functioning tab element", async () => {
        const page = await newE2EPage();
        await page.setContent(tabTemplate());
        await page.waitForChanges();
        const tabContainer = await page.find("ux-tab-container");
        const tabButton1 = await page.find("ux-tab-button[name='tab-1']");
        const tabButton2 = await page.find("ux-tab-button[name='tab-2']");
        const tabButton3 = await page.find("ux-tab-button[name='tab-3']");
        const tab1 = await page.find("ux-tab[name='tab-1']");
        const tab2 = await page.find("ux-tab[name='tab-2']");
        const tab3 = await page.find("ux-tab[name='tab-3']");
        expect(tabContainer).toHaveClass("hydrated");
        expect(tab2).toHaveClass("is-active");
        expect(tabButton2).toHaveClass("is-active");
        const eventListener = await page.spyOnEvent("uxActiveTabSet");
        await tabButton1.click();
        await page.waitForChanges();
        expect(eventListener).toHaveReceivedEventDetail("ux-tab-content1");
        expect(tab2).not.toHaveClass("is-active");
        expect(tabButton2).not.toHaveClass("is-active");
        expect(tab1).toHaveClass("is-active");
        expect(tabButton1).toHaveClass("is-active");
        await tabButton3.click();
        await page.waitForChanges();
        expect(eventListener).toHaveReceivedEventDetail("ux-tab-content3");
        expect(tab1).not.toHaveClass("is-active");
        expect(tabButton1).not.toHaveClass("is-active");
        expect(tab2).not.toHaveClass("is-active");
        expect(tabButton2).not.toHaveClass("is-active");
        expect(tab3).toHaveClass("is-active");
        expect(tabButton3).toHaveClass("is-active");
    });

    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-tab-container active-tab-id="">
                <ux-tab name="Tab 1" tab-id="ux-tab-content1">Test 1</ux-tab>
                <ux-tab name="Tab 2" tab-id="ux-tab-content2">Test 2</ux-tab>
            </ux-tab-container>`
        );
        const el = await page.find("ux-tab-container");
        const tabButton = await page.find("ux-tab-button");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
        expect(tabButton.classList.contains("is-active")).toBe(true);
    });

    it("should render valid html", async () => {
        await testValidHtml(tabTemplate());
    });

    it("should match to snapshot and have variant set to folder", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-tab-container active-tab-id="" variant="folder">
                <ux-tab name="Tab 1" tab-id="ux-tab-content1">Test 1</ux-tab>
                <ux-tab name="Tab 2" tab-id="ux-tab-content2">Test 2</ux-tab>
            </ux-tab-container>`
        );
        const el = await page.find("ux-tab-container");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
        expect(el.classList.contains("ux-tab-container--folder")).toBe(true);
    });
});

function tabTemplate() {
    return `
    <ux-tab-container active-tab-id="ux-tab-content2">
        <ux-tab name="tab-1" tab-id="ux-tab-content1">
            Tab 1
        </ux-tab>
        <ux-tab name="tab-2" tab-id="ux-tab-content2">
            Tab 2
        </ux-tab>
        <ux-tab name="tab-3" tab-id="ux-tab-content3">
            Tab 3
        </ux-tab>
    </ux-tab-container>
    `;
}
